import { useMutation } from 'react-apollo';

import {
  contactCreate as contactCreateMutation,
  contactUpdate as contactUpdateMutation,
} from '../../../../graphql/mutations/contacts';

const useContacts = () => {
  const [contactCreate] = useMutation(contactCreateMutation);
  const [contactUpdate] = useMutation(contactUpdateMutation);

  const onContactCreate = async ({
    firstName,
    lastName,
    emailAddress,
    phoneNumber,
  }) => {
    const {
      data: {
        contactCreate: { contact },
      },
    } = await contactCreate({
      variables: {
        input: {
          first_name: firstName,
          last_name: lastName,
          contact_emails: emailAddress ? [{ email_address: emailAddress }] : [],
          contact_phones: phoneNumber ? [{ phone_number: phoneNumber }] : [],
        },
      },
    });
    return contact;
  };

  const onContactUpdate = async ({
    contactId,
    firstName,
    lastName,
    emailAddress,
    emailAddressId,
    phoneNumber,
    phoneNumberId,
  }) => {
    const {
      data: {
        contactUpdate: { contact },
      },
    } = await contactUpdate({
      variables: {
        input: {
          contact_id: contactId,
          first_name: firstName,
          last_name: lastName,
          create_contact_emails:
            emailAddress && !emailAddressId
              ? [{ email_address: emailAddress }]
              : [],
          update_contact_emails:
            emailAddress && emailAddressId
              ? [
                  {
                    contact_email_id: emailAddressId,
                    email_address: emailAddress,
                  },
                ]
              : [],
          delete_contact_email_ids:
            !emailAddress && emailAddressId ? [emailAddressId] : [],
          create_contact_phones:
            phoneNumber && !phoneNumberId
              ? [{ phone_number: phoneNumber }]
              : [],
          update_contact_phones:
            phoneNumber && phoneNumberId
              ? [
                  {
                    contact_phone_id: phoneNumberId,
                    phone_number: phoneNumber,
                  },
                ]
              : [],
          delete_contact_phone_ids:
            !phoneNumber && phoneNumberId ? [phoneNumberId] : [],
        },
      },
    });

    return contact;
  };
  return {
    onContactCreate,
    onContactUpdate,
  };
};

export default useContacts;
